import React from 'react';
import { fixNumber, formatTime } from '../../utils/utils';
import gsap from 'gsap';

import bitcoinIcon from '../../assets/images/bitcoin-icon.svg'
import '../../scss/current-price.scss'
import { LiveMenuState } from './LiveRound';

interface CurrentPriceProps{
    btcPrice:number;
    nextContestTime:number,
    totalTime:number;
    isMobile:boolean;   
}

export default class CurrentPrice extends React.Component<CurrentPriceProps> {

    mainDiv = React.createRef<HTMLDivElement>(); 
    labelQuestion = React.createRef<HTMLParagraphElement>(); 

    /**
     * Hide Label
     */
    public hide( liveMenuState : LiveMenuState) {

        const openHeight = 300;
        const div =this.mainDiv.current;
        gsap.to(div , {height: liveMenuState === LiveMenuState.open ? 0 : openHeight , duration:0.5})
        
    }


    render(){

        
        return (
            <div ref={this.mainDiv} className={this.props.isMobile ? "current-price" : "current-price-desktop"}>
                <div className="price">
                    <div className="value">
                        <p className="amount">{fixNumber(this.props.btcPrice)}</p>
                        <img className="bitcoin-icon" src={bitcoinIcon} alt="bitcoin icon"></img>
                    </div>
                    <p>Price locks in {formatTime(this.props.totalTime - this.props.nextContestTime)} s</p>
                </div>
                <p ref={this.labelQuestion} className="question">Will Bitcoin close above or below? </p>
            </div>
        )
    }

  
}


